import languages from '../languages';
import ipCheck from '../ipCheck';
import { getJSON, post } from './ultile';
import globalConfig from '@utiles/officialStore/globalConfig';
import { updateDefaultParam } from '../../plugins/AnalyzePoint';
import {
  storeLocation,
  storePayTypeList,
  storeProductList,
  setDefaultPayType,
  setLastedPayType,
  storeServerId,
  storeServerName,
  storeCoinName,
  getStoreHrefParam,
  storeCurLocation,
  storeProductId,
  getLocaLclStor,
  storeCpProductId,
  setCreditCardRecord,
  getCreditCardRecord,
  setPaypalAgreementRecord,
  getPaypalAgreementRecord
} from './storager';
import coupon, { SET_GAME_COUPON_ITEM_USE_BTN } from './coupon';
import coins from './coins';
import login from './login';
import page from './page';
import activity from './activity';
import award from './award';
import { filterPayType } from '../_tempAllStoreHanlder';
import globalGameInfoConfig, {
  ZTMSLG_GAMES,
  DTMSLG_GAMES
} from '@configs/officialTopup/globalGameInfoConfig';
import cart, {
  CLEAR_CART,
  UPDATE_CAN_USE_CART,
  SET_CART_QUANTITY_LIMIT,
  UPDATE_CART_LIST_OF_AMOUNT
} from './cart';
import jp, {
  JPSTORE_SHORT_HOST,
  JPSTORE_PRICE_LIST,
  JPSTORE_INIT_DATA_NEW,
  JPSTORE_USER_ROLE,
  JPSTORE_SERVER_LIST
} from './jp';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
import { checkIsInWebview } from '@utiles/officialStore/sdkCtrl';
import { isNumber } from '@utiles/index';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
const MAIN_HOST = globalConfig.getMainHost();
languages.init();
updateCommonParamsInfo({
  language: languages.language
});

export const UPDATE_GAMEID = 'update_gameid';
export const GET_SEPC_GAME_INFO = 'get_spec_game_info';
export const UPDATE_LASTED_ROLE = 'update_lasted_role';
export const GET_SERVER_LIST = 'get_server_list';
export const GET_ROLE_LIST = 'get_role_list';
export const UPDATE_SERVER_LIST = 'update_server_list';
export const UPDATE_HISTORY_SERVER_LIST = 'update_history_server_list';
export const UPDATE_ROLE_LIST = 'update_role_list';
export const SWITCH_ROLE = 'switch_role';
export const SWITCH_SERVER = 'switch_server';
export const UPDATE_PRODUCT_LIST = 'update_product_list';
export const UPDATE_PRODUCT_TYPES = 'update_product_types';
export const GET_PRODUCT_LIST = 'get_product_list';
export const GET_LASTED_STORE_ROLE = 'get_lasted_store_role';
export const SWITCH_LANGUAGE = 'switch_language';
export const GET_SERVER_LIST_ACTION = `https://gstore.${MAIN_HOST}/ajax/server_list_history`;
export const GET_ROLE_LIST_ACTION = `https://gstore.${MAIN_HOST}/ajax/get_user_role`;
export const GET_PRODUCT_LIST_ACTION = `https://gstore.${MAIN_HOST}/init_data`;
export const GET_PRE_PRODUCT_LIST_ACTION = `https://gstore.${MAIN_HOST}/show_product`;
export const STORE_HOST = `//gstore.${MAIN_HOST}/`;
export const LOAD_INIT_DATA = 'loadStoreInitData';
export const RELOAD_WAY = 'reloadPayWay';
export const SET_PAY_TYPES = 'setPayType';
export const POST_ORDER = 'postOrder';
export const SET_LOAD_CHANNEL_STATUS = 'set_load_channel_status';
export const SET_SHOW_CHANNEL_STATUS = 'set_show_channel_status';
export const DETECT_LOGIN = 'detectLogin';
export const LOAD_BANK_PRICES = 'load_bank_prices';
export const GET_INVOICE = 'get_invoice';
export const DELETE_CARD = 'deleteCard';
export const LOAD_PAYTYPE_LIST_DATA = 'load_paytype_list_data';
export const LOAD_COINS_PAYTYPE_LIST_DATA = 'load_coins_paytype_list_data';
export const UPDATE_PC_SERVER_ID = 'update_pc_server_id';
export const UPDATE_ROLE_NAME = 'update_role_name';
export const SET_DEFAULT_PAYTYPE = 'set_default_paytype';
export const SET_HAS_LOAD_PAYTYPE = 'set_has_load_paytype';
export const SET_PAYTYPE = 'set_paytype';
export const UPDATE_LASTED_PAYTYPE = 'update_lasted_paytype';
export const UPDATE_PRODUCT_LIST_OF_AMOUNT = 'update_product_list_of_amount';
export const UPDATE_SHOW_DETAIL_POPUP_DATA = 'update_look_detail_popup_data';
export const CLOSE_DETAIL_POPUP = 'close_detail_popup';
export const UPDATE_LOADING = 'update_loading';
export const UPDATE_ALL_PAYTYPE_PRICE_MAP = 'update_all_paytype_price_map';
export const UPDATE_HAS_SELECT_PRODUCT = 'update_has_select_product';
export const DELETE_WELFARE_RECORD = 'delete_welfare_record';
export const UPDATE_COINS_SUBMIT_TYPE = 'update_coins_submit_type';
export const CLEAR_PRODUCT_LIST = 'clear_product_list';
export const INIT_WELFARE_BTN = 'init_welfare_btn';
export const UPDATE_VISIBLE_TOKEN_LOGIN_POPUP =
  'update_visible_token_login_popup';
export const UPDATE_HIDE_SUBMIT = 'update_hide_submit';
export const SET_CREDIT_CARD = 'set_credit_card';
export const GET_CARD_SCHEMES_ACTION = 'get_card_schemes_action';
const SET_CREDIT_CARD_LIST = 'set_credit_card_list';
const LOAD_JS = 'loadJs';
export const SET_INIT_DATA = 'setStoreInitData';
const LOAD_BANK_PRICES_URL = 'show_product';
const GET_INVOICE_URL = 'virtual_account/get_invoice';
const RELOAD_WAY_ACTION = 'get_piece_list';
const FETCH_GAME_INFO_ACTION = `https://gstore.${MAIN_HOST}/ajax/game_info`;
const GET_LASTED_STORE_ROLE_ACTION = `https://gstore.${MAIN_HOST}/last_pay_info`;
export const UPDATE_SHOW_CURRENCY = 'update_show_currency';
const UPDATE_AMOUNT_LEVEL_MAP = 'updateAmountLevelMap';
export const PAGE_TYPE = {
  currency: 'currency',
  package: 'package',
  coin: 'coin'
};
export const TOGGLE_PAYPAL_AGREEMENT = 'toggle_paypal_agreement';
export const GET_PRE_PRODUCT_LIST = 'get_pre_product_list';
export const MODIFY_THIRD_PARTY_PAYMENT_INFOS =
  'modify_third_party_payment_infos'; // 修改用户第三方支付信息
export const MODIFY_AREA_LIMIT_INFO = 'modify_area_limit_info'; // 修改地区限制数据
export const GET_LOCATION_CURRENCY_LIST = 'get_location_currency_list'; // 获取支付地区可用币种
export const GET_ZIP_CODE_LIST = 'get_zip_code_list'; // 获取ZipCode列表
export const GET_VAT = 'get_vat'; // 获取税费
export const MODIFY_TAX = 'modify_tax'; // 修改税费
export const MODIFY_ZIPCODE = 'modify_zipcode'; // 修改zipcode

export const UPDATE_SELECT_STATE = 'update_select_state'; // 修改下弹框显示状态

export const SHOW_PRODUCT_DETAIL_POPUP = 'show_product_detial_popup'; // 展示查看商品弹窗状态
export const CLOSE_PRODUCT_DETAIL_POPUP = 'close_product_detial_popup'; // 关闭查看商品弹窗状态
export const GET_ROLE_LIST_ONLY = 'get_role_list_only'; // 获取角色列表,不进行其他操作
export const SET_GLOBAL_TIPS_VISIBLE = 'set_global_tips_visible'; // 设置全局提示弹窗状态
export const OPEN_GLOBAL_TIPS = 'open_global_tips'; // 打开全局提示弹窗内容

export const GET_FB_APPID = 'get_fb_appid'; // 获取facebook appid
export const UPDATE_FB_APPID = 'update_fb_appid'; // 更新facebook appid
export const GET_FB_APPID_URL = `https://gpassport.${MAIN_HOST}/web_facebook/get_app_id`; // 获取facebook appid
export const INIT_LANG_LIST = 'init_lang_list'; // 设置语言列表
export const GET_THIRD_PARTY_PRODUCT_ID = 'get_third_party_product_id';

export const UPDATE_IS_AUTO_MATCH_PRODUCT = 'update_is_auto_match_product'; // 更新是否自动匹配商品

export const COIN_TYPE = 0;
export const VOUCHER_TYPE = 1;

// 有代金币的游戏，需要在渠道列表隐藏加码
const HAS_CURRENCY_GAME = [211, 209, 213, 215];
const currentPaypalAgreement = getPaypalAgreementRecord() || false;

export const matchRoleIdAndRoleName = function (roleList, roleId) {
  let match = false;
  let roleName = '';
  if (roleList != undefined && roleList.length > 0) {
    for (let item of roleList) {
      if (item.roleID == roleId) {
        roleName = item.roleName;
        match = true;
      }
    }
  }
  if (!match && roleList.length === 1) {
    roleId = roleList[0].roleID;
    roleName = roleList[0].roleName;
  }

  // 角色大于1个时，让玩家自己选
  if (!match && roleList.length > 1) {
    roleId = null;
    roleName = null;
  }

  return { roleId, roleName };
};

let formatLocation = function (allLocation) {
  let locations = [];
  // eslint-disable-next-line no-unused-vars
  for (let value in allLocation) {
    let name = allLocation[value];
    let locationObj = {
      name,
      value
    };
    locations.push(locationObj);
  }
  return locations;
};

let initGameId = () => {
  let gameId =
    globalConfig.getHrefParam('gameId') ||
    globalConfig.getHrefParam('gameID') ||
    globalConfig.getHrefParam('game_id') ||
    '';
  if (!gameId || !isNumber(gameId)) {
    globalConfig.jumpErrorPage();
    return;
  }
  if (ZTMSLG_GAMES.includes(+gameId)) {
    gameId = 191;
  }
  if (DTMSLG_GAMES.includes(+gameId)) {
    gameId = 285;
  }
  updateCommonParamsInfo({
    gameId
  });
  return gameId;
};

export default {
  state: {
    gameId: initGameId(),
    serverList: null,
    historyServerList: null,
    roleList: null,
    serverId: null,
    roleId: null,
    roleName: null,
    pcServerId: null,
    productList: [],
    productTypes: [],
    loadingProduct: false,
    lastedServerId: '',
    lastedRoleId: '',
    lastedRoleName: '',
    lastedGame: '',
    letter: languages.getAll(),
    lang: languages.language,
    langList: languages.getLangText(),
    isRtlDirection: languages.isRtlDirection(),
    showCurrency: '',
    locations: [],
    curLocation: '',
    max_extra_ratio: '',
    is_dai_chong: false,
    allLocations: getLocaLclStor(),
    bankPricesData: '',
    loadChannel: false,
    showChannel: false,
    defaultPaytype: {},
    paytype: {},
    hasLoadPaytype: false,
    lastedPaytype: {}, // 切换商品前选的渠道
    lookDetailItem: {},
    showBtnOfDetailPopup: false,
    showDetailPopup: false,
    loading: false,
    allPaytypePriceMap: [], // 当前地区全部渠道的价格表对应关系
    hasSelectProduct: false,
    boolInitWelfareBtnRecord: false, // 是否已经初始化过储值福利的按钮
    welfareBtnRecord: [], // 记录储值福利中的按钮是否已点击过，点击过就不在数组里面
    isCoinsSubmitType: false,
    visibleTokenLoginPopup: false, // 消费代币是uid登录需要弹窗令牌登录弹窗
    hideSubmit: false, // 是否隐藏提单
    amountLevelMap: {}, // 购物车定价表
    creditCardList: [], // 信用卡列表
    creditCard: '', // 信用卡支付方式,
    coinName: '', // 游戏币名称
    voucherCoinName: '', //代金币名称
    coinIcon: '', //游戏币图标
    voucherCoinIcon: '', //代金币图标
    subCoinType: 0, //拆单内容类型，0：游戏币，1：代金币
    extraCoinType: 0, //加码内容类型，0：游戏币，1：代金币
    directPayCoinType: 0, //汇款内容类型，0：游戏币，1：代金币
    directPayExtraCoinType: 0, //汇款加码内容类型，0：游戏币，1：代金币
    white: '0', // 是否是白名单
    security: '0', // 是否是安全登陆
    clientId: '', // 客户端唯一id
    paypalAgreement: currentPaypalAgreement, // Paypal快捷支付勾选状态
    isInWebview: checkIsInWebview(), // 是否在webview内
    ipZipCode: '', // 美国ip地区zipCode
    zipCode: '', // 美国地区zipCode
    locationModifyCount: 0, // 地区修改次数
    maxLocationModifyCount: 0, // 地区修改最大次数
    ipLocation: '', // ip定位地区
    defaultCurrency: '', // 默认货币
    curTax: 0, // 当前税费

    selectState: false, // 下拉框显示状态
    productDetailPopupVisible: false, // 查看商品弹窗状态
    productDetailPopupProduct: {}, // 查看商品弹窗商品

    shareFbAppId: '', // facebook分享appid
    globalTipsVisible: false, // 全局提示弹窗状态
    globalTipsContent: '', // 全局提示弹窗内容
    isAutoMatchProduct: true // 是否自动匹配商品
  },
  mutations: {
    [UPDATE_IS_AUTO_MATCH_PRODUCT](state, bool) {
      state.isAutoMatchProduct = bool;
    },
    [UPDATE_AMOUNT_LEVEL_MAP](state) {
      let levelMap = {};
      state?.paytype?.price_list?.length &&
        state?.paytype?.price_list.forEach(item => {
          item.AMOUNT_LEVEL_LIST &&
            item.AMOUNT_LEVEL_LIST.length &&
            item.AMOUNT_LEVEL_LIST.forEach(levelItem => {
              levelMap[`level_${levelItem}`] = item;
            });
        });
      state.amountLevelMap = levelMap;
    },
    [UPDATE_HIDE_SUBMIT](state, bool) {
      state.hideSubmit = bool;
    },
    [UPDATE_VISIBLE_TOKEN_LOGIN_POPUP](state, bool) {
      state.visibleTokenLoginPopup = bool;
    },
    [UPDATE_COINS_SUBMIT_TYPE](state, bool) {
      state.isCoinsSubmitType = bool;
    },
    [INIT_WELFARE_BTN](state, recordBtnArr) {
      state.welfareBtnRecord = recordBtnArr;
      state.boolInitWelfareBtnRecord = true;
    },
    [DELETE_WELFARE_RECORD](state, deleteBtnName) {
      const locIndex = state.welfareBtnRecord.indexOf(deleteBtnName);
      if (locIndex === -1) return;
      state.welfareBtnRecord.splice(locIndex, 1);
    },
    [UPDATE_HAS_SELECT_PRODUCT](state, status) {
      state.hasSelectProduct = status;
    },
    [UPDATE_ALL_PAYTYPE_PRICE_MAP](state, info) {
      state.allPaytypePriceMap.splice(0);
      state.allPaytypePriceMap = state.allPaytypePriceMap.concat(info);
    },
    [UPDATE_LOADING](state, status) {
      state.loading = status;
    },
    [CLOSE_DETAIL_POPUP](state, status) {
      state.showDetailPopup = status;
    },
    [UPDATE_SHOW_DETAIL_POPUP_DATA](state, data) {
      const { item, showBtn, show } = data;
      state.lookDetailItem = item;
      state.showBtnOfDetailPopup = showBtn;
      state.showDetailPopup = show;
    },
    [UPDATE_LASTED_PAYTYPE](state, paytype) {
      state.lastedPaytype = paytype;
    },
    [SET_PAYTYPE](state, paytype) {
      state.paytype = paytype;
      this.commit(UPDATE_AMOUNT_LEVEL_MAP);
      let newProductList = state.productList.map(item => {
        return Object.assign(item, {
          amountLevel: state.amountLevelMap[`level_${item.AMOUNT_LEVEL}`] || ''
        });
      });
      let newCartList = state.cart.cartList.map(item => {
        const amountLevel =
          state.amountLevelMap[`level_${item.AMOUNT_LEVEL}`] || '';
        if (!amountLevel) {
          errorReport(ERROR_TYPE.MATCH_CART_PRODUCT_LEVEL_FAIL, {
            f_pay_typel: paytype?.f_pay_type,
            pay_type: paytype?.pay_type,
            product_id: item?.PRODUCT_ID,
            cp_product_id: item?.CP_PRODUCT_ID,
            remark: item?.REMARK
          });
        }
        return Object.assign(item, {
          amountLevel
        });
      });
      this.commit(UPDATE_PRODUCT_LIST, newProductList);
      this.commit(UPDATE_CART_LIST_OF_AMOUNT, newCartList);
    },
    [SET_HAS_LOAD_PAYTYPE](state, status) {
      state.hasLoadPaytype = status;
    },
    [SET_DEFAULT_PAYTYPE](state, data) {
      state.defaultPaytype = data.default_paytype || {};
    },
    [SET_CREDIT_CARD_LIST](state, list) {
      state.creditCardList = list;
    },
    [SET_CREDIT_CARD](state, card) {
      state.creditCard = card;
      setCreditCardRecord(card);
    },
    [UPDATE_PC_SERVER_ID](state, id) {
      state.pcServerId = id;
    },
    [UPDATE_ROLE_NAME](state, name) {
      state.roleName = name;
    },
    // 更新游戏id
    [UPDATE_GAMEID](state, gameId) {
      state.gameId = +gameId;
    },
    // 切换语言
    [SWITCH_LANGUAGE](state) {
      state.letter = languages.getAll();
      state.lang = languages.language;
      state.isRtlDirection = languages.isRtlDirection();
      state.hasLoadPaytype = false;
    },
    // 切换服务器
    [SWITCH_SERVER](state, id) {
      state.serverId = id;
    },
    // 切换角色
    [SWITCH_ROLE](state, id) {
      state.roleId = id;
      updateDefaultParam('ext13', id);
    },
    // 获取商品列表
    [UPDATE_PRODUCT_LIST](state, productList) {
      state.productList = productList;
    },
    [UPDATE_PRODUCT_TYPES](state, typeList) {
      state.productTypes = typeList;
    },
    // 更新伺服器列表
    [UPDATE_SERVER_LIST](state, serverList) {
      state.serverList = serverList;
    },
    [UPDATE_HISTORY_SERVER_LIST](state, historyServerList) {
      state.historyServerList = historyServerList;
    },
    // 更新角色列表
    [UPDATE_ROLE_LIST](state, roleList) {
      state.roleList = roleList;
    },
    [UPDATE_SHOW_CURRENCY](state, value) {
      state.showCurrency = value;
    },
    [UPDATE_LASTED_ROLE](state, params) {
      state.lastedGame = params.lastedGame;
      state.lastedServerId = params.lastedServerId;
      state.lastedRoleId = params.lastedRoleId;
      state.lastedRoleName = params.lastedRoleName;
    },
    [SET_SHOW_CHANNEL_STATUS](state, status) {
      state.showChannel = status;
    },
    [SET_LOAD_CHANNEL_STATUS](state, status) {
      state.loadChannel = status;
    },
    [SET_INIT_DATA](state, data) {
      // todo 江美游戏特殊处理
      if (+state.gameId === 2) {
        Object.assign(data, {
          all_locations: { JP: '日本' },
          current_location: 'JP'
        });
      }
      state.locations = formatLocation(data.all_locations);
      state.curLocation = data.current_location;

      state.coinName = data.coin_name;
      state.voucherCoinName = data.voucher_coin_name;
      state.coinIcon = data.coin_icon;
      state.voucherCoinIcon = data.voucher_coin_icon;
      state.subCoinType = data.sub_coin_type;
      state.extraCoinType = data.extra_coin_type;
      state.directPayCoinType = data.direct_pay_coin_type;
      state.directPayExtraCoinType = data.direct_pay_extra_coin_type;
      state.white = data.white;
      state.security = data.security;
      state.clientId = data.client_id;
      state.max_extra_ratio = data.max_extra_ratio;
      state.is_dai_chong = !!(
        data.ext_info && data.ext_info.show_pay_tips == 1
      );

      state.ipZipCode = data?.ip_zip_code || '';
      state.zipCode = data?.zip_code || '';
      state.locationModifyCount = data?.location_modify_count || 0;
      state.maxLocationModifyCount = data?.max_location_modify_count || 0;
      state.ipLocation = data?.ip_location || '';
      state.defaultCurrency = data?.default_currency || '';

      // 赋空用户切换id
      storeProductId('');
      storeCpProductId(data.cp_product_id);
      storeCurLocation(data.current_location);
      storeLocation(state.locations);
      storePayTypeList(data.paytype_list);
      storeProductList(data.product_list);
      setLastedPayType(data?.paytype);
      setDefaultPayType(data?.paytype || data.paytype_list[0]);
      storeServerId(data.server_id);
      storeServerName(data.server_name);
      storeCoinName(data.coinName);
      state.allLocations = getLocaLclStor();
    },
    [SET_PAY_TYPES](state, payType) {
      state.curPayType = payType;
    },
    [LOAD_BANK_PRICES](state, bankPricesData) {
      state.bankPricesData = bankPricesData;
    },
    [TOGGLE_PAYPAL_AGREEMENT](state) {
      state.paypalAgreement = !state.paypalAgreement;
      setPaypalAgreementRecord(state.paypalAgreement);
    },
    // 修改地区次数
    [MODIFY_AREA_LIMIT_INFO](state, info) {
      if (!info.force) {
        state.locationModifyCount += 1;
      }
      state.curLocation = info.location_code;
      state.zipCode = info.zip_code;
      state.defaultCurrency = info.default_currency;
    },
    // 修改税费
    [MODIFY_TAX](state, tax) {
      state.curTax = tax || 0;
    },
    // 修改zipcode
    [MODIFY_ZIPCODE](state, zipcode) {
      state.zipCode = zipcode;
    },
    // 修改下弹窗显示状态
    [UPDATE_SELECT_STATE](state, status) {
      state.selectState = status;
    },
    // 展示查看商品弹窗状态
    [SHOW_PRODUCT_DETAIL_POPUP](state, product) {
      state.productDetailPopupVisible = true;
      state.productDetailPopupProduct = product;
    },
    // 关闭查看商品弹窗状态
    [CLOSE_PRODUCT_DETAIL_POPUP](state) {
      state.productDetailPopupVisible = false;
    },
    [SET_GLOBAL_TIPS_VISIBLE](state, status) {
      state.globalTipsVisible = status;
    },
    [OPEN_GLOBAL_TIPS](state, content) {
      state.globalTipsVisible = true;
      state.globalTipsContent = content || '';
    },
    [INIT_LANG_LIST](state, langList) {
      state.langList = langList;
    },
    [UPDATE_FB_APPID](state, id) {
      state.shareFbAppId = id;
    }
  },
  getters: {
    // 根据搜索结果过滤商品列表
    getProductListByName: state => val => {
      return state.productList.filter(
        item =>
          item.CP_PRODUCT_DESC?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
      );
    },
    getProductListByPrice: state => val => {
      return state.productList.filter(item => item.GAME_AMOUNT.includes(val));
    },
    isRtlDirection: state => {
      return state.isRtlDirection;
    },
    hasLastedPaytype: state => {
      return (
        state.lastedPaytype &&
        state.lastedPaytype?.f_pay_type &&
        state.lastedPaytype?.pay_type
      );
    },
    gameInfoConfig: state => {
      return globalGameInfoConfig[state.gameId] || {};
    },
    isJpPlatform: state => {
      // todo 江美游戏特殊处理
      return +state.gameId === 2;
    },
    hidePaytypeDisountTag: () => {
      return false;
    },
    // 拆单内容名称
    subCoinNama: state => {
      return +state.subCoinType === VOUCHER_TYPE
        ? state.voucherCoinName
        : state.coinName;
    },
    // 拆单内容图标
    subCoinIco: (state, getters) => {
      if (+state.subCoinType === VOUCHER_TYPE) {
        return getters.voucherIco;
      }
      return getters.coinIco;
    },
    // 加码内容名称
    extraCoinName: state => {
      return +state.extraCoinType === VOUCHER_TYPE
        ? state.voucherCoinName
        : state.coinName;
    },
    // 加码内容图标
    extraCoinIco: (state, getters) => {
      if (+state.extraCoinType === VOUCHER_TYPE) {
        return getters.voucherIco;
      }
      return getters.coinIco;
    },
    // 游戏币ico
    coinIco(state, getters) {
      return state.coinIcon || '';
    },
    // 代金币ico
    voucherIco(state, getters) {
      return state.voucherCoinIcon || '';
    },
    // 商品默认图标
    productDefaultIco(_state, getters) {
      return '';
    },
    // 汇款内容名称
    directPayCoinName: state => {
      return +state.directPayCoinType === VOUCHER_TYPE
        ? state.voucherCoinName
        : state.coinName;
    },
    // 汇款内容ico
    directPayCoinIco: (state, getters) => {
      if (+state.directPayCoinType === VOUCHER_TYPE) {
        return getters.voucherIco;
      }
      return getters.coinIco;
    },
    // 汇款加码内容名称
    directPayExtraCoinName: state => {
      return +state.directPayExtraCoinType === VOUCHER_TYPE
        ? state.voucherCoinName
        : state.coinName;
    },
    // 汇款加码内容ico
    directPayExtraCoinIco: (state, getters) => {
      if (+state.directPayExtraCoinType === VOUCHER_TYPE) {
        return getters.voucherIco;
      }
      return getters.coinIco;
    }
  },
  actions: {
    [GET_THIRD_PARTY_PRODUCT_ID]({ _commit }, params) {
      const ACTION = 'ajax/' + GET_THIRD_PARTY_PRODUCT_ID;
      return new Promise(resolve => {
        getJSON(STORE_HOST + ACTION, params).then(({ errmsg, res }) => {
          if (!errmsg) {
            resolve(res);
          } else {
            resolve(false);
          }
        });
      });
    },
    [CLEAR_PRODUCT_LIST]({ commit }) {
      commit(UPDATE_LOADING, true);
      commit(CLEAR_CART);
      commit(SET_SHOW_CHANNEL_STATUS, false);
      commit(SET_HAS_LOAD_PAYTYPE, false);
      commit(UPDATE_CAN_USE_CART, { can_use_cart: false });
      commit(SET_DEFAULT_PAYTYPE, { default_paytype: {} });
      commit(SET_PAYTYPE, {});
      commit(UPDATE_PRODUCT_LIST, []);
      commit(UPDATE_PRODUCT_TYPES, []);
      commit(UPDATE_SHOW_CURRENCY, '');
      commit(SET_INIT_DATA, {
        all_locations: {},
        current_location: '',
        coin_name: '',
        max_extra_ratio: '',
        is_dai_chong: false,
        cp_product_id: '',
        paytype_list: []
      });
      commit(UPDATE_HAS_SELECT_PRODUCT, false);
      commit(SET_GAME_COUPON_ITEM_USE_BTN, false);
      commit(UPDATE_LOADING, false);
    },
    // 获取游戏储值是否可用
    [GET_SEPC_GAME_INFO](_res, { gameId }) {
      return new Promise(resolve => {
        getJSON(FETCH_GAME_INFO_ACTION, { game_id: gameId }).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            if (res.res.data && res.res.data.GAME_ID) {
              if (+res.res.data.WEB_THIRD_SWITCH === 1) {
                resolve(true);
              } else {
                resolve(false);
              }
            }
          } else {
            resolve(false);
          }
        });
      });
    },

    // 更新伺服器列表
    [GET_SERVER_LIST]({ commit, state, getters }) {
      const params = {
        game_id: state.gameId
      };
      let url = GET_SERVER_LIST_ACTION;
      if (getters.isJpPlatform) {
        url = JPSTORE_SHORT_HOST + JPSTORE_SERVER_LIST;
        Object.assign(params, {
          user_id_cross: state.login.uid
        });
      }

      return new Promise(resolve => {
        getJSON(url, params).then(res => {
          // 所有伺服器
          commit(UPDATE_SERVER_LIST, res.data.all);
          // 历史伺服器
          commit(UPDATE_HISTORY_SERVER_LIST, res.data.history);
          resolve(res.data);
        });
      });
    },
    // 更新角色列表
    [GET_ROLE_LIST]({ commit, state, getters }, param) {
      let url = GET_ROLE_LIST_ACTION;
      const params = {
        game_id: state.gameId,
        server_id: param
      };
      if (getters.isJpPlatform) {
        url = JPSTORE_SHORT_HOST + JPSTORE_USER_ROLE;
        Object.assign(params, {
          user_id_cross: state.login.uid
        });
      }
      return new Promise(resolve => {
        commit(UPDATE_LOADING, true);
        getJSON(url, params).then(res => {
          commit(UPDATE_ROLE_LIST, res.data);
          if (res.data.length !== 0) {
            let realTargetRoleId =
              state.roleId || globalConfig.getHrefParam('roleId');
            let { roleId, roleName } = matchRoleIdAndRoleName(
              state.roleList,
              realTargetRoleId
            );
            commit(SWITCH_ROLE, roleId);
            commit(UPDATE_ROLE_NAME, roleName);
          } else {
            commit(SWITCH_ROLE, null);
            commit(UPDATE_ROLE_NAME, '');
          }

          // 从 /ajax/get_user_role 接口返回数据查 state.roleId 是否有效
          let isRoleIdinResObj = res.data.filter(d => {
            return d.roleID == state.roleId;
          });
          let loadProductRightNow =
            res.data.length > 0 &&
            (isRoleIdinResObj.length ||
              state.roleId == globalConfig.getHrefParam('roleId'));
          resolve({
            loadProductRightNow,
            roleId: state.roleId
          });
          commit(UPDATE_LOADING, false);
        });
      });
    },
    // 获取商品列表
    [GET_PRODUCT_LIST]({ commit, state, dispatch, getters, rootState }) {
      const requestParams = {
        gameId: state.gameId,
        serverId: state.pcServerId,
        roleId: state.roleId,
        roleName: encodeURIComponent(state.roleName),
        language: state.lang,
        h5: globalConfig.getHrefParam('pageSource') === 'h5' ? '1' : ''
      };
      // 20240423 ROV东南亚版371不需要传pageType参数 需求人：吴师源
      const reallyRequestParams = requestParams;
      let url = GET_PRODUCT_LIST_ACTION;
      if (getters.isJpPlatform) {
        url = JPSTORE_SHORT_HOST + JPSTORE_INIT_DATA_NEW;
      }
      return new Promise(resolve => {
        commit(UPDATE_LOADING, true);
        commit(SET_SHOW_CHANNEL_STATUS, false);
        commit(SET_HAS_LOAD_PAYTYPE, false);
        getJSON(url, reallyRequestParams).then(res => {
          if (!res.data?.paytype_list?.length) {
            errorReport(ERROR_TYPE.PAY_TYPE_LIST_EMPTY);
          }
          if (!res.data?.product_list?.length) {
            errorReport(ERROR_TYPE.PRODUCT_LIST_EMPTY);
          }
          commit(UPDATE_CAN_USE_CART, res.data);
          commit(SET_CART_QUANTITY_LIMIT, res.data);
          commit(SET_DEFAULT_PAYTYPE, res.data);
          let paytype = res.data.paytype_list.filter(item => {
            return (
              item?.f_pay_type == state.defaultPaytype?.f_pay_type &&
              item?.pay_type == state.defaultPaytype?.pay_type
            );
          });
          if (paytype && paytype.length && paytype[0]) {
            paytype = paytype[0];
          }
          if (paytype.child && paytype.child.length) {
            paytype = Object.assign({}, paytype, {
              selectChildIndex: 0
            });
          }
          commit(SET_PAYTYPE, paytype);
          let productList = [];
          let productTypes = ['typeall'];
          const initList = res.data.product_list;
          let prefix = 'type';
          const isCustomProductType = rootState.page.isCustomProductType;
          const customProductType = rootState.page.customProductType;
          if (initList && initList.length !== 0) {
            initList.map(item => {
              productList = productList.concat(item.list);
              if (isCustomProductType && customProductType) {
                item.list &&
                  item.list.length &&
                  item.list.forEach(ele => {
                    let typeKey = '';
                    if (
                      ele.CP_PRODUCT_EXT &&
                      ele.CP_PRODUCT_EXT.TYPE &&
                      customProductType[prefix + ele.CP_PRODUCT_EXT.TYPE]
                    ) {
                      typeKey = prefix + ele.CP_PRODUCT_EXT.TYPE;
                    } else {
                      typeKey = prefix + 'other';
                    }
                    if (productTypes.indexOf(typeKey) < 0) {
                      productTypes = productTypes.concat(typeKey);
                    }
                  });
              } else {
                productTypes = productTypes.concat(item.catalog);
              }
            });
            if (isCustomProductType) {
              for (let i = 0; i < productTypes.length; i++) {
                for (let k = 0; k < i; k++) {
                  let pdIOrder = +customProductType[productTypes[i]].order;
                  let pdKOrder = +customProductType[productTypes[k]].order;
                  if (pdIOrder < pdKOrder) {
                    let temp = productTypes[k];
                    productTypes.splice(k, 1, productTypes[i]);
                    productTypes.splice(i, 1, temp);
                  }
                }
              }
            }
          }
          // productList遍历，给商品项加分类标识别 + 商品项映射定价表
          productList = productList.map(item => {
            let typeKey = '';
            if (isCustomProductType) {
              if (
                item.CP_PRODUCT_EXT &&
                item.CP_PRODUCT_EXT.TYPE &&
                customProductType[prefix + item.CP_PRODUCT_EXT.TYPE]
              ) {
                typeKey = prefix + item.CP_PRODUCT_EXT.TYPE;
              } else {
                typeKey = prefix + 'other';
              }
            } else {
              typeKey = item.PRODUCT_TYPE || '';
            }
            return Object.assign({}, item, {
              itemType: typeKey,
              amountLevel:
                state.amountLevelMap[`level_${item.AMOUNT_LEVEL}`] || ''
            });
          });
          commit(UPDATE_PRODUCT_LIST, productList);
          if (getters.isJpPlatform) {
            commit(UPDATE_PRODUCT_TYPES, []);
          } else {
            commit(UPDATE_PRODUCT_TYPES, productTypes);
          }
          commit(UPDATE_SHOW_CURRENCY, res.data.product_currency);
          commit(UPDATE_LOADING, false);
          commit(SET_INIT_DATA, res.data);
          if (res.data.scripts && res.data.scripts.fingerprint_url) {
            dispatch(LOAD_JS, res.data.scripts.fingerprint_url);
          }
          commit(SET_GAME_COUPON_ITEM_USE_BTN, true);
          let loadProductRightNow;
          // 不同区服务可能会存在同样的roleId 的情况下重复加载产品项目
          resolve(loadProductRightNow);
          // 加载Paypal风控 需分别注入两个脚本,参考：https://developer.paypal.com/limited-release/fraudnet/integrate/
          // 前置脚本
          const scriptPre = document.createElement('script');
          scriptPre.type = 'application/json';
          scriptPre.setAttribute(
            'fncls',
            'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99'
          );
          const jsonText = {
            f: res.data.client_id,
            s: res.data.sandbox
              ? 'GMEI_U2JRV7KXL7T9W'
              : `GMEI_${res.data.game_id}_WJUQADPG5BZ7G_RT`,
            sandbox: +res.data.sandbox
          };
          scriptPre.textContent = JSON.stringify(jsonText);
          document.body.appendChild(scriptPre);
          // paypal脚本
          const scriptAfter = document.createElement('script');
          scriptAfter.type = 'text/javascript';
          scriptAfter.src = 'https://c.paypal.com/da/r/fb.js';
          document.body.appendChild(scriptAfter);
        });
      });
    },

    // 切换语言
    [SWITCH_LANGUAGE]({ commit }, param) {
      languages.setLanguage(param);
      commit(SWITCH_LANGUAGE);
    },

    [GET_LASTED_STORE_ROLE]({ commit, state }) {
      commit(UPDATE_LASTED_ROLE, {
        lastedServerId: '',
        lastedRoleId: '',
        lastedRoleName: '',
        lastedGame: ''
      });
      return new Promise((resolve, reject) => {
        getJSON(GET_LASTED_STORE_ROLE_ACTION, {
          game_id: state.gameId
        }).then(res => {
          if (res.res.result == 1 && res.data && res.data.ROLE_ID) {
            commit(UPDATE_LASTED_ROLE, {
              lastedGame: res.data.GAME_ID,
              lastedServerId: res.data.SERVER_ID,
              lastedRoleId: res.data.ROLE_ID,
              lastedRoleName: res.data.ROLE_NAME
            });
          }
          resolve();
        }, reject);
      });
    },
    [RELOAD_WAY]({ getters, commit, state }, params = {}) {
      return new Promise((resolve, reject) => {
        let param = getStoreHrefParam();
        param = { ...param, ...params };
        let host = '';
        let path = '';
        if (getters.isJpPlatform) {
          host = JPSTORE_SHORT_HOST;
          path = JPSTORE_PRICE_LIST;
        } else {
          host = STORE_HOST;
          path = RELOAD_WAY_ACTION;
        }
        getJSON(host + path, param).then(({ errmsg, data }) => {
          if (!errmsg) {
            data.paytype_list = filterPayType(param, data.paytype_list);
            // 该渠道功能没有开发，暂时前端过滤掉
            if (getters.isJpPlatform && state.gameId !== '2') {
              const originPayTypeList = data.paytype_list;
              const filterPayTypeList = originPayTypeList.filter(item => {
                return (
                  !(
                    item.f_pay_type === 'gmo' && item.pay_type === 'convenience'
                  ) && !(item.f_pay_type === 'gmo' && item.pay_type === 'edy')
                );
              });
              data.paytype_list = filterPayTypeList;
            }

            storePayTypeList(data.paytype_list);
            setDefaultPayType(data.paytype_list[0]);
            resolve(true);
          } else {
            reject(errmsg);
          }
        });
      });
    },

    [POST_ORDER]({ getters }, params) {
      return new Promise((resolve, reject) => {
        const ACTION = params?.f_pay_type + '/submit';
        const host = getters.isJpPlatform ? JPSTORE_SHORT_HOST : STORE_HOST;
        post(host + ACTION, params, {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            resolve(res);
          } else {
            reject({ errmsg, res });
          }
        });
      });
    },

    // 加载第三方js
    [LOAD_JS](_res, params) {
      return new Promise(resolve => {
        getJSON(params, {}).then(() => {
          resolve();
        });
      });
    },

    // 加载银行汇款价格
    [LOAD_BANK_PRICES]({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        if (state.bankPricesData) {
          resolve(state.bankPricesData);
        } else {
          getJSON(STORE_HOST + LOAD_BANK_PRICES_URL, params).then(
            ({ errmsg, data }) => {
              if (!errmsg) {
                commit(LOAD_BANK_PRICES, data);
                resolve(data);
              } else {
                reject(new Error(errmsg));
              }
            }
          );
        }
      });
    },

    // 獲取發票信息
    [GET_INVOICE](_res, params) {
      return new Promise((resolve, reject) => {
        post(STORE_HOST + GET_INVOICE_URL, params, {
          withCredentials: true,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            resolve(res);
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    },

    [DELETE_CARD](_res, params) {
      return new Promise((resolve, reject) => {
        let ACTION = 'del_user_pay_type_infos';
        if (params?.f_pay_type === 'world_pay') {
          ACTION = 'world_pay/del_user_pay_type_infos';
        }
        post(STORE_HOST + ACTION, params, {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            resolve(res);
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    },

    [LOAD_PAYTYPE_LIST_DATA]({ commit, getters, state }) {
      let params = getStoreHrefParam();
      let host = '';
      let path = '';
      if (getters.isJpPlatform) {
        host = JPSTORE_SHORT_HOST;
        path = JPSTORE_PRICE_LIST;
      } else {
        host = STORE_HOST;
        path = RELOAD_WAY_ACTION;
      }
      return new Promise(resolve => {
        getJSON(host + path, params).then(({ errmsg, data }) => {
          if (!errmsg) {
            data.paytype_list = filterPayType(params, data.paytype_list);
            // 该渠道功能没有开发，暂时前端过滤掉
            if (getters.isJpPlatform && state.gameId !== '2') {
              const originPayTypeList = data.paytype_list;
              const filterPayTypeList = originPayTypeList.filter(item => {
                return (
                  !(
                    item.f_pay_type === 'gmo' && item.pay_type === 'convenience'
                  ) && !(item.f_pay_type === 'gmo' && item.pay_type === 'edy')
                );
              });
              data.paytype_list = filterPayTypeList;
            }

            storePayTypeList(data.paytype_list);
            setDefaultPayType(data.paytype_list[0]);
            commit(SET_HAS_LOAD_PAYTYPE, true);
            commit(SET_SHOW_CHANNEL_STATUS, true);
            commit(UPDATE_LOADING, false);
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    // 获取商品列表
    [GET_PRE_PRODUCT_LIST]({ state, getters }) {
      return new Promise(resolve => {
        // 日本平台无此接口 不需要获取预览商品列表
        if (getters.isJpPlatform) {
          resolve([]);
        } else {
          let gameId = state.gameId;
          getJSON(GET_PRE_PRODUCT_LIST_ACTION, {
            game_id: gameId,
            f_pay_type: 'third_party',
            pay_type: 'third_party',
            currency: 'USD',
            game_currency: 'APPLE_CURRENCY'
            // pageType: getPageType()
          }).then(({ errmsg, data }) => {
            if (!errmsg) {
              resolve(data);
            } else {
              reject(new Error(errmsg));
            }
          });
        }
      });
    },
    [GET_CARD_SCHEMES_ACTION]({ commit }, data) {
      let params = getStoreHrefParam();
      const requestParams = Object.assign(params, data);
      const ACTION = 'credit_card/get_card_schemes';
      return new Promise(resolve => {
        getJSON(STORE_HOST + ACTION, requestParams).then(({ errmsg, res }) => {
          if (!errmsg) {
            commit(SET_CREDIT_CARD_LIST, res.data);
            // 是否有上次选择的记录且记录在当前列表中
            const creditCardRecord = getCreditCardRecord();
            const hasCreditCardRecord =
              creditCardRecord?.length && res.data.includes(creditCardRecord);
            commit(
              SET_CREDIT_CARD,
              hasCreditCardRecord ? creditCardRecord : res.data[0]
            );
            resolve(res);
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    },
    //修改用户第三方支付信息
    [MODIFY_THIRD_PARTY_PAYMENT_INFOS]({ commit }, params) {
      return new Promise((resolve, reject) => {
        post(STORE_HOST + MODIFY_THIRD_PARTY_PAYMENT_INFOS, params, {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            commit(MODIFY_AREA_LIMIT_INFO, params);
            resolve(res);
          } else {
            reject(new Error(errmsg));
          }
        });
      });
    },
    // 获取支付地区可用币种
    [GET_LOCATION_CURRENCY_LIST]({ commit, state }, params) {
      return new Promise(resolve => {
        getJSON(STORE_HOST + GET_LOCATION_CURRENCY_LIST, {
          game_id: state.gameId,
          ...params
        }).then(({ res }) => {
          resolve(res);
        });
      });
    },
    // 获取ZipCode列表
    [GET_ZIP_CODE_LIST]({ commit, state }, params) {
      return new Promise(resolve => {
        getJSON(`${STORE_HOST}ajax/` + GET_ZIP_CODE_LIST, {
          state: params.state
        }).then(({ res }) => {
          resolve(res);
        });
      });
    },
    // 获取税率
    [GET_VAT]({ commit, state }, params) {
      return new Promise(resolve => {
        getJSON(`${STORE_HOST}ajax/` + GET_VAT, {
          game_id: state.gameId,
          ...params
        }).then(({ res }) => {
          resolve(res);
        });
      });
    },
    // 获取角色列表
    [GET_ROLE_LIST_ONLY]({ commit, state, getters }, param) {
      commit(UPDATE_LOADING, true);
      let url = GET_ROLE_LIST_ACTION;
      const params = {
        game_id: state.gameId,
        server_id: param
      };
      if (getters.isJpPlatform) {
        url = JPSTORE_SHORT_HOST + JPSTORE_USER_ROLE;
        Object.assign(params, {
          user_id_cross: state.login.uid
        });
      }
      return new Promise(resolve => {
        getJSON(url, params).then(res => {
          commit(UPDATE_LOADING, false);
          resolve(res.data);
        });
      });
    },
    // 获取FB appid
    [GET_FB_APPID]({ commit, state }) {
      return new Promise(resolve => {
        getJSON(GET_FB_APPID_URL, {
          game_id: state.gameId
        }).then(res => {
          if (res?.data) {
            commit(UPDATE_FB_APPID, res.data);
          }
        });
      });
    }
  },
  modules: {
    coupon,
    login,
    coins,
    jp,
    activity,
    page,
    award,
    cart,
    ipCheck
  }
};
